export const defaultLocale = 'fr'
export const locales = [
  {
    code: 'fr',
    name: 'Français'
  },
  {
    code: 'de',
    name: 'Deutsch'
  }
]
